module.exports = __webpack_public_path__ + "img/Icon-Blue.0362d7fa.png";